import { ReactNode } from "react";
import { Grid, Paper, SxProps } from "@mui/material";
import Text from "~/components/ui-library/components/typography/Text";
import TextCaption from "~/components/ui-library/components/typography/TextCaption";
import { Obj } from "~/components/ui-library/types";

export type RegistriesByCategoryProps = {
  categoryOptions: { name: string; text: string; icon: ReactNode }[];
  categories: string[];
  onFacetsChange: (value: Partial<Obj>) => void;
  sx?: SxProps;
};

export const RegistriesByCategory = ({
  categoryOptions,
  categories,
  onFacetsChange,
  sx = {},
}: RegistriesByCategoryProps) => {
  return (
    <Grid container spacing={3}>
      {categoryOptions.map(({ name, text, icon }) => {
        const isActive = categories.includes(name);
        return (
          <Grid
            key={name}
            sx={sx}
            size={{
              xs: 12,
              sm: 6,
              md: 4,
            }}
          >
            <Paper
              sx={{
                p: 2,
                display: "block",
                cursor: "pointer",
                ...(isActive
                  ? { background: "rgba(145, 71, 255, 0.2)" }
                  : { opacity: categories.length > 0 ? 0.4 : 1 }),
              }}
              onClick={() => {
                onFacetsChange({
                  categories: isActive ? [] : [name],
                });
              }}
            >
              <Grid container>
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                  }}
                >
                  {icon}
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                  size="grow"
                >
                  <Text bold textTransform="capitalize">
                    {name.replace(/-/g, " ")}
                  </Text>
                  <TextCaption secondary textTransform="uppercase">
                    {text}
                  </TextCaption>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};
